<span class="button" [ngStyle]="style" (click)="click()">
    {{ loading ? "" : label }}
    <span
      *ngIf="loading"
      class="h-[24px] w-[24px] border border-[#fff] relative rounded-full border-l-0 border-t-0 border-r animate-spin transition-all ease-in-out duration-200 flex items-center justify-center"
    >
      <span class="bg-[#081A46] h-[23px] rounded-full absolute z-[9999]"></span>
    </span>
  </span>
